import ContextButton from './contextButton'
import EditableButton from './editableButton'

export default class ContextMenu {
  constructor (scene) {
    this.scene = scene
    this.buttons = []
    this.isShown = true
    this.dontHideOnClick = false
  }

  addButton (text, callback) {
    this.buttons.push(new ContextButton(this.scene, 0, 0, text, () => { callback(); if (!this.dontHideOnClick) { this.hide() } }))
  }

  addEditable (index, text, value, callback) {
    this.buttons.push(new EditableButton(this.scene, 0, 0, text, value, callback, index))
  }

  show (x, y) {
    for (var i = 0; i < this.buttons.length; i++) {
      this.buttons[i].unhide(x, y + i * 50)
    }
    this.isShown = true
  }

  hide () {
    for (var i = 0; i < this.buttons.length; i++) {
      this.buttons[i].hide()
    }
    this.isShown = false
  }

  toggle (x, y) {
    if (this.isShown) {
      this.hide()
    } else {
      this.show(x, y)
    }
  }

  clear () {
    for (var i = 0; i < this.buttons.length; i++) {
      this.buttons[i].destroy()
    }
    this.buttons = []
  }
}
